import styled from 'styled-components';

export const MaintenanceContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) =>
    theme.isHorizonGridVisualRefresh ? "'Inter', sans-serif" : "'Lato', sans-serif"};
  justify-content: space-around;
  margin: 0;
  min-height: 100vh;
  padding: 0 2em;
  text-align: center;
`;

export const PrimaryLogo = styled.img`
  width: 75vw;

  @media screen and (min-width: 900px) {
    width: 60vw;
  }
`;

export const SkySpecsLogo = styled.img`
  width: 40vw;

  @media screen and (min-width: 900px) {
    width: 20vw;
  }
`;
